import React, { createRef } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import TodayIcon from '@material-ui/icons/Today';
import ReactDatePicker from 'react-date-picker';

import {
  getLocalizedDate
} from 'app/utils/Utils';

import {
  formatDate,
  formatShortDate
} from 'shared/utils/Utils';

import {
  setSelectedDate
} from 'shared/actions/datePickerActions';

import config from 'shared/config/config';

const styles = theme => ({
  datePicker: {
    position: 'relative',
    zIndex: 2,
    float: 'left',
    fontSize: '1rem',
    fontWeight: 600,
    padding: '0.5rem 0.9rem',
    cursor: 'pointer',
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    borderRadius: '3px',
    border: '1px solid #dcdcdc',
    boxShadow: '0 0 2px #dcdcdc',
    color: '#2b8eb0',
    minWidth: '13rem',
    fontFamily: config.root_font_family
  },
  hiddenDatePicker: {
    position: 'absolute',
    zIndex: 0,
    top: 0,
    left: 0,
    marginLeft: '1rem',
    fontFamily: config.root_font_family
  },
});

class DatePicker extends React.Component {
  constructor(props) {
    super(props);

    this.datePicker = createRef();

    this.state = {
    }
  }

  chooseDate() {
    this.datePicker.current.openCalendar();
  }

  getTileClassName({ date }) {
    const dateStr = formatShortDate(date);

    for (let d of this.props.dates) {
      if (d === dateStr) {
        return "enabled";
      }
    }
  }

  onCalendarChange(date) {
    console.log('onCalendarChange');
    this.props.setSelectedDate(date)
    .then(() => {
      if (this.props.onCalendarChange) {
        this.props.onCalendarChange(date);
      }
    });
  }

  newCurrentDate() {
    let date = new Date();
    return date;
  }

  render() {
    const { classes, selectedDate, locale } = this.props;

    let datePickerValue = selectedDate || this.newCurrentDate();
    let formattedDate = getLocalizedDate(locale, datePickerValue);

    return (
      <div style={{position: 'relative', float: 'left'}}>
        <button className={classes.datePicker} onClick={this.chooseDate.bind(this)}>
          <TodayIcon style={{float: 'left', margin: '0.05rem 0.5rem 0 0'}} />
          <span style={{float: 'left'}}>{formattedDate}</span>
        </button>
        <ReactDatePicker ref={this.datePicker}
          className={classes.hiddenDatePicker}
          tileClassName={this.getTileClassName.bind(this)}
          onChange={this.onCalendarChange.bind(this)}
          defaultValue={datePickerValue}
          locale={locale}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  dates: state.datePickerReducer.dates,
  selectedDate: state.datePickerReducer.selectedDate,
  locale: state.messagesReducer.locale,
});

export default connect(mapStateToProps, { setSelectedDate })(withStyles(styles)(DatePicker));
